import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpRepository } from './http.repository';
import { GlobalConfig } from '../configs/GlobalConfig';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { FileMetaData } from '../interfaces/rest/FileMetaData';
import { FileType, TranslationTypes } from '../interfaces/rest/FileType';
import {MasterTranslation} from "../interfaces/rest/MasterTranslation";

@Injectable()
export class FileRepository {

    constructor(protected http: HttpClient,
                protected httpRepository: HttpRepository) {
    }

    /**
     * Get file by file ID.
     * @param fileId
     * @returns {Observable<FileMetaData>}
     */
    getFile(fileId: string|number): Observable<FileMetaData> {
        return this.httpRepository.get(`${GlobalConfig.endpoints.files}/${fileId}`);
    }

    /**
     * Add a new file.
     * @param {FileMetaData} file
     * @param type
     * @returns {Observable<FileMetaData>}
     */
    addFile(file: FileMetaData, type = ''): Observable<FileMetaData> {
        if (type !== '' && TranslationTypes.hasOwnProperty(type)) {
            const obj = {
                type: type,
                fileBytes: file.fileByte
            };
            return this.httpRepository.post<MasterTranslation>(GlobalConfig.endpoints.translation, obj).pipe(
                map((response: MasterTranslation) => {
                    // Return only the file metadata.
                    return response.translationFile;
                }));
        }  else {
            return this.httpRepository.post(GlobalConfig.endpoints.files, file);
        }
    }

    streamingFileUpload(file: File, fileType: string): Observable<FileMetaData> {
      const fileName = encodeURIComponent(file.name);
      const endpoint = `${GlobalConfig.endpoints.streamingFileUpload}/${fileType}/${fileName}`;

      return this.httpRepository.post(endpoint, file, { "Content-Type": file.type || 'application/octet-stream' }, true);
    }

    deleteFile(fileId: string|number) {
        // add delete file functionality later.
        return this.getFile(fileId); // remove this.
    }

    /**
     * Get files by file type.
     * @param {FileType} fileType
     * @returns {Observable<Array<FileMetaData>>}
     */
    getFilesByType(fileType: FileType): Observable<Array<FileMetaData>> {
        return this.httpRepository.get(`${GlobalConfig.endpoints.files}?type=${FileType[fileType]}`);
    }

    getFileContentAsString(fileUrl: string): Observable<string> {
        return this.http.get<any>(fileUrl, {'responseType': 'text' as 'json'});
    }

    getFileContentAsBlob(fileUrl: string): Observable<Blob> {
        return this.http.get<any>(fileUrl, {'responseType': 'blob' as 'json'});
    }

    getMasterTranslations(): Observable<Array<MasterTranslation>> {
        return this.httpRepository.get(GlobalConfig.endpoints.masterTranslation);
    }
}
